import { ILoggingSettings, ISectionLogger, LoggingSection } from "@multiweb/logging";
import { createDefaultSectionLoggerFactory } from "Logging/defaultLogger";
import { IHTTPResult } from "../../Global/Base/Comunication/HTTPRequest";
import { WorkerMessage, WorkerResponseMessage } from "./WorkerMessages";

export interface ISerializedError extends IHTTPResult {
    typeName: string | undefined;
}

export class SerializedError implements ISerializedError {
    public status: number | undefined;
    public statusText: string | undefined;
    public response: any | undefined;
    public typeName: string | undefined;

    public getResponseHeader(_header: string): string | null {
        return null;
    }
}

export interface IBasicWorkerInitializationMessageData {
    readonly loggingSettings: ILoggingSettings;
    readonly loggingSection: LoggingSection;
}

export class BasicWorker {
    private _portGen: number = 0;
    private _ports: Map<number, MessagePort> = new Map();

    /**
     * Určeno i pro potomky BasicWorkeru.
     */
    protected _logger: ISectionLogger | undefined;

    constructor() {
        (self as any).onmessage = this._processMessage.bind(this); // pokud bych pouzil tohle self.onmessage = this._processMessage , tak v metode _processMessage bude this obsahovat objekt self :-(
        // klidne by to slo udelat i takhle self.onmessage = (e) => this._processMessage(e);
        if ("onconnect" in self)
            (/*<SharedWorkerGlobalScope>*/self as any).onconnect = this._processConnect.bind(this);
    }

    /**
     * Musí být provoláno z potomků BasicWorkeru při inicializaci.
     */
    public initialize(initData: IBasicWorkerInitializationMessageData): void {
        // Nejsou tu zohledněny custom implementace.
        const defaultSectionLoggerFactory = createDefaultSectionLoggerFactory(initData.loggingSettings);
        this._logger = defaultSectionLoggerFactory.create(initData.loggingSection);
    }

    private _processMessage(e: MessageEvent): void {
        switch ((e.data as WorkerMessage).type) {
            case "connect":
                this._processConnect(e);
                break;
        }
    }

    private _processConnect(e: MessageEvent): void {
        const port: MessagePort = e.ports[0];
        if (port) {
            const portID = ++this._portGen;
            this._ports.set(portID, port);
            port.onmessage = this._processPortMessage.bind(this, portID);
        }
    }

    protected _processPortMessage(portID: number, e: MessageEvent): void {
        switch ((e.data as WorkerMessage).type) {
            case "disconnect": {
                const port = this._ports.get(portID);
                if (port) {
                    this._ports.delete(portID);
                    (port as any).onmessage = null;
                }
                return;
            }
        }
    }

    public sendMessage(portID: number, msg: WorkerResponseMessage): void {
        try {
            const port = this._ports.get(portID);
            if (port)
                port.postMessage(msg);
        } catch (ex) {
            this._logger!.error(ex);
        }
    }

    public cloneException(ex: Error): ISerializedError {
        let result = new SerializedError();
        if (Reflect.has(ex, "status"))
            result.status = Reflect.get(ex, "status");
        if (ex instanceof Object) {
            const prot = Reflect.getPrototypeOf(ex);
            result = this._copyPrimitivePropertyValues(ex);
            result.typeName = prot?.constructor?.name;
        } else {
            result.typeName = typeof ex;
            result.response = ex + "";
        }
        return result;
    }

    private _copyPrimitivePropertyValues(obj: any): any {
        const result: any = {};
        for (const prop of Reflect.ownKeys(obj)) {
            const v = obj[prop];
            if (v instanceof Object)
                result[prop] = JSON.stringify(v);
            else
                result[prop] = v;
        }
        return result;
    }
}
